import { ChangeEvent } from 'react';
import { useTheme } from '@mui/material';
import { ButtonPrimary, SearchFilter, TextM } from 'app/components';
import { InstallmentsFiltersIcon } from 'app/components/Icons';
import { TFilterItems } from 'app/components/SearchFilter/SearchFilter';
import {
  ApplicationsContentFiltersCount,
  Container,
  FilterArea,
} from './styles';

export const APPLICATION_SEARCH_FILTER_ITEMS: TFilterItems[] = [
  {
    name: 'ID',
    parameterName: 'id',
  },
  {
    name: 'ID Externo',
    parameterName: 'external_id',
  },
  {
    name: 'CCB',
    parameterName: 'sequential_id',
  },
];

type TApplicationsSearchFiltersProps = {
  inputValue: string;
  filterCount: number;
  selectedFilter?: string;
  containerWidth?: string;
  onSearch: () => void;
  onClearInput: () => void;
  onOpenFilters: () => void;
  onInputChange: (evt: ChangeEvent<HTMLInputElement>) => void;
  onSelectFilterItem: (selectedFilterValue: TFilterItems) => void;
};

const ApplicationsSearchFilters = ({
  inputValue,
  filterCount,
  selectedFilter,
  containerWidth = '100%',
  onSearch,
  onClearInput,
  onOpenFilters,
  onInputChange,
  onSelectFilterItem,
}: TApplicationsSearchFiltersProps) => {
  const theme = useTheme();

  return (
    <Container style={{ width: containerWidth }}>
      <FilterArea>
        <SearchFilter
          inputValue={inputValue}
          handleClearInput={onClearInput}
          handleInputChange={onInputChange}
          filterItems={APPLICATION_SEARCH_FILTER_ITEMS}
          handleSelectFilterItem={onSelectFilterItem}
          selectedFilter={selectedFilter}
          handleSearch={onSearch}
        />
      </FilterArea>
      <ButtonPrimary
        style={{ maxWidth: filterCount > 0 ? '202px' : '170px' }}
        typeVariant="outline"
        iconPosition="left"
        btnIcon={
          <InstallmentsFiltersIcon
            color={theme.palette.brand.primary.base as string}
          />
        }
        onClick={onOpenFilters}
      >
        <TextM
          weight="Bold"
          style={{
            marginLeft: '11px',
            color: theme.palette.brand.primary.base as string,
          }}
        >
          Mais filtros
        </TextM>
        {filterCount > 0 && (
          <ApplicationsContentFiltersCount>
            {filterCount}
          </ApplicationsContentFiltersCount>
        )}
      </ButtonPrimary>
    </Container>
  );
};

export default ApplicationsSearchFilters;
